
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "HomeTitle",
})
export default class HomeTitle extends Vue {}
